import type { ServiceCalendarListScope } from "@/lib/service/calendarLocalWeek";

const SCOPES: ReadonlyArray<{ id: ServiceCalendarListScope; label: string }> = [
  { id: "day", label: "Today" },
  { id: "all_scheduled", label: "All scheduled" },
  { id: "all_unscheduled", label: "All unscheduled" },
];

export function ServiceCalendarListScopeToggle({
  scope,
  onChange,
  disabled,
}: {
  scope: ServiceCalendarListScope;
  onChange: (next: ServiceCalendarListScope) => void;
  disabled?: boolean;
}) {
  return (
    <div
      role="tablist"
      aria-label="Schedule list scope"
      className="inline-flex flex-nowrap overflow-x-auto rounded-lg bg-gray-100 p-0.5 text-sm dark:bg-zinc-800"
    >
      {SCOPES.map((tab) => {
        const active = tab.id === scope;
        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={active}
            type="button"
            disabled={disabled}
            onClick={() => onChange(tab.id)}
            className={
              "shrink-0 whitespace-nowrap rounded-md px-3 py-1 text-sm font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-60 " +
              (active
                ? "bg-white text-gray-900 shadow-sm dark:bg-zinc-900 dark:text-zinc-100"
                : "text-gray-600 hover:text-gray-900 dark:text-zinc-400 dark:hover:text-zinc-200")
            }
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
